package ir.hosen.resume.util

enum class ProjectMock(val src: String, val url: String, val title: String) {
    GEM_DESKTOP(src = "/gem_desktop.png", url = "https://gemapps.top/", title = "Gem Desktop"),
    GEM_ANDROID(src = "/gem_android.jpg", url = "https://gemapps.top/", title = "Gem Android"),
    GEM_TV(src = "/gem_tv.png", url = "https://gemapps.top/", title = "Gem TV"),
    DANA(src = "/dana.png", url = "https://done.tech/dana/", title = "Dana Voice Assistant"),
    DONE_TV(src = "/done_tv.png", url = "https://done.tech/done-tv/", title = "Done TV"),
}